<p>The <code>alt</code> attribute is meant to help users not miss any content, so make sure your text is helpful to anyone not seeing the image. </p>

<h4>Keyboard interaction</h4>
<table class="table table-bordered">
  <tbody>
  <tr>
    <td class="col-xs-3">
      <code>
        LEFT_ARROW
      </code>
    </td>
    <td class="col-xs-9">
      Move to a previous slide
    </td>
  </tr>
  <tr>
    <td class="col-xs-3">
      <code>
        RIGHT_ARROW
      </code>
    </td>
    <td class="col-xs-9">
      Move to a next slide
    </td>
  </tr>
  <tr>
    <td class="col-xs-3">
      <code>SPACE</code> or <code>ENTER</code>
    </td>
    <td class="col-xs-9">
      Move to a next slide
    </td>
  </tr>
  </tbody>
</table>
